import React, { Component } from 'react';
// import { Link } from 'react-router-dom';

//import Slider from "react-animated-slider";
//import "react-animated-slider/build/horizontal.css";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Parallax,  Navigation} from 'swiper';
import "../../css/slider-animations.css";
import "swiper/css";
import "../../css/homeslider.css";

SwiperCore.use([Parallax, Autoplay,  Navigation]);




class HomeSlider1 extends Component {
	constructor(props) {
		super(props);
		
		this.navigationNextRef = React.createRef(null);
		this.navigationPrevRef = React.createRef(null)
	}
    render() {
        const sliderContent = this.props.data
        const {btnText,hideBtn,show2Btn,btn2Text,contentWrapperCls} = this.props
        const contentCls = contentWrapperCls || ""
        const btnCls = this.props.btnCls || ""
        
        
        return (
            <>
				<Swiper className="home-slider2"	
					speed= {1500}
					parallax= {true}
					loop={false}
					autoplay = {{
						delay: 3000,
					}}					
					onSwiper={(swiper) => {
						// Delay execution for the refs to be defined
						setTimeout(() => {
						  // Override prevEl & nextEl now that refs are defined
						  swiper.params.navigation.prevEl = this.navigationPrevRef.current
						  swiper.params.navigation.nextEl = this.navigationNextRef.current

						  // Re-init navigation
						  swiper.navigation.destroy()
						  swiper.navigation.init()
						  swiper.navigation.update()
						})
					}}
					 
					modules={[Autoplay, Navigation]}
				>	

					{sliderContent.map((item, index) => {
						// Helipad görseli için özel background position
						const isHelipad = item.image && (item.image.toString().includes('heliport') || item.image.toString().includes('helicopter'));
						const bgPosition = isHelipad ? 'center 30%' : 'center center';
						
						return (
						<SwiperSlide 
							key={index} 
							className="slider-content" 
							style={{ 
								background: `url('${item.image}') no-repeat ${bgPosition}`,
								backgroundSize: 'cover'
							}}
						>							<div className={`inner ${contentCls}`}>
								{item.title && <h1 data-swiper-parallax="-500">{item.title}</h1> }
								{item.description && <p data-swiper-parallax="-1000">{item.description}</p>}
								{ hideBtn ? "" :  show2Btn ? (
									<>
										<button data-swiper-parallax="-1500" className={btnCls}>{btnText}</button>
										<button data-swiper-parallax="-2000" className={btnCls}>{btn2Text}</button>
									</>
									) : (
										<button data-swiper-parallax="-1500" className={btnCls}>{btnText}</button>
									)
								}
							</div>
						</SwiperSlide>
						);
					})}	
					<div className="swiper-button" style={{zIndex : 1}}>
						<div className="swiper-button-prev previousButton" ref={this.navigationPrevRef}><i className="las la-angle-left"></i></div>
						<div className="swiper-button-next nextButton" ref={this.navigationNextRef}><i className="las la-angle-right"></i></div>
					</div>	
				</Swiper>

            </>
        )
    }
}
export default HomeSlider1;